// src/pages/ProductDetails/InverterInterface.jsx
import React, { useState, useEffect } from 'react';

import './InverterShared.css';
import './InverterInterface.css';

const InverterInterface = () => {
  const [systemState, setSystemState] = useState('MAINS_ON');
  const [activeIndex, setActiveIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(true);

  const mainsOnImage = "https://res.cloudinary.com/dhbjxspxa/image/upload/v1779340922/ChatGPT_Image_May_21_2026_at_10_13_29_AM_lhsvwp.png";
  const upsModeOffImage = "https://res.cloudinary.com/dhbjxspxa/image/upload/v1779341001/ChatGPT_Image_May_20_2026_at_08_55_20_PM_klru85.png";
  const upsModeOnImage = "https://res.cloudinary.com/dhbjxspxa/image/upload/v1779371323/Inverter_main_output_on_beqbvb.png";

  let currentImage = mainsOnImage;
  let currentAltText = "Zynventics Inverter - Mains ON";
  
  if (systemState === 'UPS_OFF') {
    currentImage = upsModeOffImage;
    currentAltText = "Zynventics Inverter - UPS Mode (Output OFF)";
  } else if (systemState === 'UPS_ON') {
    currentImage = upsModeOnImage;
    currentAltText = "Zynventics Inverter - UPS Mode (Output ON)";
  }

  const LED_INDICATORS = [
    { 
      top: '35%', 
      left: '20%', 
      title: systemState === 'MAINS_ON' ? 'Mains ON' : 'UPS Mode', 
      desc: systemState === 'MAINS_ON' ? 'Indicates grid power is available.' : 'Main output is off. Inverter is in UPS mode.', 
      color: systemState === 'MAINS_ON' ? 'green' : 'yellow' 
    },
    { top: '45%', left: '20%', title: 'Charging', desc: 'Battery is currently charging.', color: 'yellow' },
    { 
      top: '55%', 
      left: '20%', 
      title: 'UPS Mode', 
      desc: systemState === 'UPS_ON' ? 'Inverter is powering your home.' : 'Main output is off. Inverter is in UPS mode.', 
      color: systemState === 'UPS_ON' ? 'green' : 'yellow' 
    },
    { top: '65%', left: '20%', title: 'Low Battery', desc: 'Please reduce load. Battery nearly empty.', color: 'red' },
    { top: '75%', left: '20%', title: 'Overload', desc: 'Too many appliances connected.', color: 'red' },
  ];

  useEffect(() => {
    let timeout;
    if (isPlaying) {
      timeout = setTimeout(() => {
        const nextIndex = (activeIndex + 1) % LED_INDICATORS.length;
        setActiveIndex(nextIndex);

        if (nextIndex === 0) {
          setSystemState((prev) => prev === 'MAINS_ON' ? 'UPS_OFF' : 'MAINS_ON');
        } else if (nextIndex === 2) {
          setSystemState('UPS_OFF');
        }
      }, 3000); 
    }
    
    return () => clearTimeout(timeout); 
  }, [isPlaying, activeIndex, LED_INDICATORS.length]);

  const handleHotspotClick = (index) => {
    setActiveIndex(index);
    setIsPlaying(false);
    
    if (index === 0) {
      setSystemState((prev) => prev === 'MAINS_ON' ? 'UPS_OFF' : 'MAINS_ON');
    } else if (index === 2) {
      setSystemState((prev) => prev === 'UPS_ON' ? 'UPS_OFF' : 'UPS_ON');
    }
  };

  return (
    <section className="apple-section">
      <h2 className="apple-title">Intelligent Interface</h2>
      <p className="apple-subtitle">Everything you need to know, at a glance.</p>
      
      <div className="interface-container">
        <img 
          src={currentImage} 
          alt={currentAltText} 
          className="inverter-front-img" 
        />
        
        {LED_INDICATORS.map((led, index) => (
          <div 
            key={index} 
            className={`hotspot color-${led.color} ${activeIndex === index ? 'active' : ''}`} 
            style={{ top: led.top, left: led.left }}
            onClick={() => handleHotspotClick(index)}
          >
            <div className="tooltip">
              <strong>
                <span className={`led-color led-${led.color}`}></span>
                {led.title}
              </strong>
              <div style={{ marginTop: '4px', opacity: 0.9 }}>{led.desc}</div>
            </div>
          </div>
        ))}

        <div className="playback-controls">
          <button 
            type="button"
            onClick={() => setIsPlaying(!isPlaying)} 
            className="play-pause-btn"
            aria-label={isPlaying ? "Pause auto-scroll" : "Play auto-scroll"}
          >
            {isPlaying ? (
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><rect x="6" y="4" width="4" height="16"></rect><rect x="14" y="4" width="4" height="16"></rect></svg>
            ) : (
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polygon points="5 3 19 12 5 21 5 3"></polygon></svg>
            )}
            <span>{isPlaying ? 'Pause' : 'Play'}</span>
          </button>
        </div>

      </div>
    </section>
  );
};

export default InverterInterface;